// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"156cffc3","787":"23455a43"}[chunkId] + ".chunk.js";
};